import React from 'react';
import {
  DialogContent,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Typography,
  Divider,
} from '@mui/material';

const StudentForm = ({ formData, setFormData }) => {
  const classes = ['Nursery', 'LKG', 'UKG', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  const sections = ['A', 'B', 'C', 'D'];
  const bloodGroups = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
  const genders = ['male', 'female', 'other'];

  return (
    <DialogContent>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        {/* Personal Information */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
            Personal Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="First Name"
            value={formData.first_name}
            onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Last Name"
            value={formData.last_name}
            onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
            required
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Date of Birth"
            type="date"
            value={formData.date_of_birth}
            onChange={(e) => setFormData({ ...formData, date_of_birth: e.target.value })}
            InputLabelProps={{ shrink: true }}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required>
            <InputLabel>Gender</InputLabel>
            <Select
              value={formData.gender}
              label="Gender"
              onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
            >
              {genders.map((gender) => (
                <MenuItem key={gender} value={gender}>
                  {gender.charAt(0).toUpperCase() + gender.slice(1)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Blood Group</InputLabel>
            <Select
              value={formData.blood_group}
              label="Blood Group"
              onChange={(e) => setFormData({ ...formData, blood_group: e.target.value })}
            >
              {bloodGroups.map((group) => (
                <MenuItem key={group} value={group}>{group}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Religion"
            value={formData.religion}
            onChange={(e) => setFormData({ ...formData, religion: e.target.value })}
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Nationality"
            value={formData.nationality}
            onChange={(e) => setFormData({ ...formData, nationality: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Admission Date"
            type="date"
            value={formData.admission_date}
            onChange={(e) => setFormData({ ...formData, admission_date: e.target.value })}
            InputLabelProps={{ shrink: true }}
            required
          />
        </Grid>

        {/* Academic Information */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', mt: 2 }}>
            Academic Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth required>
            <InputLabel>Class</InputLabel>
            <Select
              value={formData.class}
              label="Class"
              onChange={(e) => setFormData({ ...formData, class: e.target.value })}
            >
              {classes.map((cls) => (
                <MenuItem key={cls} value={cls}>{cls}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth required>
            <InputLabel>Section</InputLabel>
            <Select
              value={formData.section}
              label="Section"
              onChange={(e) => setFormData({ ...formData, section: e.target.value })}
            >
              {sections.map((section) => (
                <MenuItem key={section} value={section}>{section}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Roll Number"
            type="number"
            value={formData.roll_number}
            onChange={(e) => setFormData({ ...formData, roll_number: e.target.value })}
            required
          />
        </Grid>

        {/* Contact Information */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', mt: 2 }}>
            Contact Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Phone Number"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Email Address"
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Address"
            value={formData.address}
            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="City"
            value={formData.city}
            onChange={(e) => setFormData({ ...formData, city: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="State/Province"
            value={formData.state}
            onChange={(e) => setFormData({ ...formData, state: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Postal Code"
            value={formData.postal_code}
            onChange={(e) => setFormData({ ...formData, postal_code: e.target.value })}
          />
        </Grid>

        {/* Parent Information */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', mt: 2 }}>
            Father's Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Father's Name"
            value={formData.father_name}
            onChange={(e) => setFormData({ ...formData, father_name: e.target.value })}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Father's Occupation"
            value={formData.father_occupation}
            onChange={(e) => setFormData({ ...formData, father_occupation: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Father's Phone"
            value={formData.father_phone}
            onChange={(e) => setFormData({ ...formData, father_phone: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Father's Email"
            type="email"
            value={formData.father_email}
            onChange={(e) => setFormData({ ...formData, father_email: e.target.value })}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', mt: 2 }}>
            Mother's Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Mother's Name"
            value={formData.mother_name}
            onChange={(e) => setFormData({ ...formData, mother_name: e.target.value })}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Mother's Occupation"
            value={formData.mother_occupation}
            onChange={(e) => setFormData({ ...formData, mother_occupation: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Mother's Phone"
            value={formData.mother_phone}
            onChange={(e) => setFormData({ ...formData, mother_phone: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Mother's Email"
            type="email"
            value={formData.mother_email}
            onChange={(e) => setFormData({ ...formData, mother_email: e.target.value })}
          />
        </Grid>

        {/* Guardian Information */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', mt: 2 }}>
            Guardian Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Guardian Name"
            value={formData.guardian_name}
            onChange={(e) => setFormData({ ...formData, guardian_name: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Guardian Relation"
            value={formData.guardian_relation}
            onChange={(e) => setFormData({ ...formData, guardian_relation: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Guardian Phone"
            value={formData.guardian_phone}
            onChange={(e) => setFormData({ ...formData, guardian_phone: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Guardian Email"
            type="email"
            value={formData.guardian_email}
            onChange={(e) => setFormData({ ...formData, guardian_email: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Guardian Address"
            value={formData.guardian_address}
            onChange={(e) => setFormData({ ...formData, guardian_address: e.target.value })}
          />
        </Grid>

        {/* Additional Information */}
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', mt: 2 }}>
            Additional Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Medical Information"
            multiline
            rows={3}
            value={formData.medical_info}
            onChange={(e) => setFormData({ ...formData, medical_info: e.target.value })}
            placeholder="Any medical conditions, allergies, or special needs..."
          />
        </Grid>
      </Grid>
    </DialogContent>
  );
};

export default StudentForm;
